import 'magnific-popup';
import 'jquery-mask-plugin';

export default class InstallationPopup {

	constructor(){
		this.$installPopupContent = $( '#x-local-install__popup' );
		this.$installLocal = $('#x-local-install--local');
		this.$installMsg = $('.x-local-install--msg');
		this.$installLocalMsg = $('#x-local-install--local--msg');
		this.$installNotLocal = $('#x-local-install--not-local');
		this.$installNotLocalMsg = $('#x-local-install--not-local--msg');
		this.$installDIY = $('#x-local-install--diy');
		this.$installForm = $('#local-zip-checker-form');
		this.$zipInput = $.hook('install-popup-input');
		this.$checkZip = $.hook('change-zip');
		this.$installLocalWarning = $('#x-local-install--warnings');
		this.$or = $('.border-bg');
		this.$decisions = $.hook( 'install-popup-decision' );
		this.$deliveryZip = $.hook('delivery-location-zip');
		this.$headerInput = $.hook('delivery-location-input');
		this.init();
	}
	init(){
		if (this.$installPopupContent.length > 0) {

			this.checkLocal();
			setTimeout( () => { this.openPopup() }, 1000 );

		}
	}

	popupOnOpen() {

		setTimeout( () => { this.$zipInput.focus() }, 100 );

		this.$zipInput.mask( '00000-000' );
		// this.$installDIY.on('click', this.closePopup.bind( this ));
		this.$installForm.on('submit', this.updateZip.bind( this ));
		this.$checkZip.on('click', this.showNotLocal.bind( this ));
		this.$decisions.on( 'click', ( e ) => this.onDecisionClick( e ) );
	}

	popupOnClose() {

		// this.$installDIY.off('click', this.closePopup.bind( this ));
		this.$installForm.off('submit', this.updateZip.bind( this ));
		this.$checkZip.off('click', this.showNotLocal.bind( this ));
		this.$zipInput.unmask();

	}

	async onDecisionClick( e ) {

		e.preventDefault();

		let $target = $(e.currentTarget);
		let cookieName = $target.data( 'cookie-name' );
		let cookieValue = $target.data( 'cookie-value' );

		let createCookieResponse;

		try {

			createCookieResponse = await $.ajax({
				url: window.mivaJS.Miva_AJAX_URL,
				data: {
					Verb: 'Create_Cookie',
					Cookie_Name: cookieName,
					Cookie_Data: cookieValue
				}
			});

		}
		catch {

			console.error( 'Error: Unable to set cookie.' );

		}

		window.location = $target.attr( 'href' );

	}

	openPopup() {

		$.magnificPopup.open({
			items: {
				src: this.$installPopupContent,
				type: 'inline'
			},
			callbacks: {
				open: () => { this.popupOnOpen() },
				close: () => { this.popupOnClose() }
			}
		});

	}

	closePopup() {

		$.magnificPopup.close();

	}

	clearInput() {

		this.$zipInput.val('');

	}

	showLocal() {
		this.$installLocal.removeClass('u-hidden');
		this.$installLocalMsg.removeClass('u-hidden');
		this.$installMsg.removeClass('u-hidden');
		this.$checkZip.removeClass('u-hidden');
		this.$installNotLocal.addClass('u-hidden');
		this.$installNotLocalMsg.addClass('u-hidden');
		this.$or.removeClass('u-flex');
	}

	showNotLocal() {
		this.$installLocal.addClass('u-hidden');
		this.$installMsg.addClass('u-hidden');
		this.$installNotLocal.removeClass('u-hidden');
		this.$installNotLocalMsg.addClass('u-hidden');
		this.$or.addClass('u-flex');
	}

	showNotLocalMsg() {
		this.$installMsg.removeClass('u-hidden');
		this.$installNotLocalMsg.removeClass('u-hidden');
		this.$installLocalMsg.addClass('u-hidden');
	}

	checkLocal( showError = false ){

		if(mivaJS.local_install.user_is_local == 1){
			this.showLocal();
			this.$or.addClass('u-flex');
		} else {
			this.$checkZip.removeClass('u-hidden');
			this.$installNotLocal.addClass('u-hidden');
			this.$installNotLocalMsg.removeClass('u-hidden');
			this.$or.removeClass('u-flex');

			if ( showError ) {

				this.setLocalMessage('');

			}

		}

	}

	setLocalMessage( message ) {

		this.$installLocalWarning.html( message );

	}

	updateZipText(newZip) {

		this.$headerInput.attr('placeholder', newZip);
		for(let zip of this.$deliveryZip) {
			$(zip).text(newZip);
		}

	}

	async updateZip( e ){

		e.preventDefault();

		var newZip = this.$zipInput.val();

		if (newZip.length != 0) {

			let createCookieResponse;

			try {

				createCookieResponse = await $.ajax({
					url: window.mivaJS.Miva_AJAX_URL,
					data: {
						Verb: 'Create_Cookie',
						Cookie_Data: newZip,
						Cookie_Name: `mvps-${mivaJS.Store_Code}-user-zip`
					}
				});

			}
			catch {

				console.error( 'Error: Unable to set cookie.' );

			}

			if ( createCookieResponse && createCookieResponse.success ) {

				let getContentSectionResponse;

				try {

					getContentSectionResponse = await $.ajax({
						url: window.mivaJS.Miva_AJAX_URL,
						data: {
							Verb: 'Get_ContentSection',
							ContentSection_Code: 'local_offers_action',
							Output_JSON: 1,
							No_DIV: 1
						}
					});

				}
				catch( error ) {

					console.error( 'Error: Unable to get content section' );

				}

				if ( getContentSectionResponse ) {

					window.mivaJS.local_install.user_is_local = getContentSectionResponse.data;

					if(getContentSectionResponse.data) {
						this.checkLocal( true );
					} else {
						this.checkLocal();
						this.showNotLocalMsg();
					}

					this.updateZipText(newZip);
					this.clearInput();

				}

			}

		}

	}

};
